import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { tembeaVideos, tembeaData } from './TembeaData';

const fixedHeight = '300px';

const SidebarSection = () => {
    const renderVideos = () => (
        tembeaVideos.map((video, index) => (
            <Box key={index} sx={{ my: 5, overflow: 'hidden', borderRadius: '1rem' }}>
                <Typography variant="h6" gutterBottom>
                    {video.title}
                </Typography>
                <iframe
                    style={{ borderRadius: '.8rem' }}
                    width="100%"
                    height="250"
                    src={video.src}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            </Box>
        ))
    );

    const renderImageCarousels = () => (
        tembeaData.map((group, index) => (
            <Box key={index} sx={{ my: 5 }}>
                <Typography variant="h6" gutterBottom>
                    {group.title}
                </Typography>
                <Swiper
                    modules={[Autoplay, EffectFade]}
                    effect="fade"
                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                    loop={true}
                    fadeEffect={{ crossFade: true }}
                    style={{ borderRadius: '1rem' }}
                >
                    {group.images.map((image, idx) => (
                        <SwiperSlide key={idx} style={{ height: fixedHeight }}>
                            <Box
                                component="img"
                                src={image.src}
                                alt={image.alt}
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    borderRadius: '1rem',
                                    display: 'block',
                                }}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Box>
        ))
    );

    return (
        <Grid item xs={12} md={4}>
            {renderVideos()}
            {renderImageCarousels()}
        </Grid>
    );
};

export default SidebarSection;